import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { SessionService } from '@app/shared/helpers';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  lambdaUrls: any = ['apps', 'apps/', '/kafkasend'];
  mfaUrls: any = ['mfa/associate', 'mfa/authenticators'];
  ownTokenUrls: any = ['/userinfo', '/dbconnections/change_password'];
  s3Urls: Array<string> = ['api/delete/file/', 'api/upload/'];
  constructor(public router: Router, private sessionService: SessionService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let api_url: string = '';
    let headers: any = {};
    let s3Headers: any = {
      'Content-Type': 'application/json',
      'x-api-version': 'v1',
      'Client-Secret': environment.s3Service.client_secret,
      'Client-Id': environment.s3Service.client_id,
    };
    if (request.url.includes('oauth/token')) {
      api_url = `https://${environment.auth.custom_domain}/oauth/token`;
    } else if (this.lambdaUrls.includes(request.url) || request.url.includes('apps/')) {
      headers['Content-Type'] = 'application/json';
      headers['Authorization'] = `Bearer ${this.sessionService.getApplicationToken()}`;
      api_url = `${environment.api_url}/${request.url}`;
    } else if (this.ownTokenUrls.includes(request.url)) {
      headers['Content-Type'] = 'application/json';
      headers['Authorization'] = `Bearer ${this.sessionService.getApplicationToken()}`;
      api_url = `https://${environment.auth.custom_domain}${request.url}`;
    } else if (this.mfaUrls.includes(request.url)) {
      api_url = `https://${environment.auth.custom_domain}/${request.url}`;
      headers['Content-Type'] = 'application/json';
      if (request.url == 'mfa/authenticators') {
        headers['Authorization'] = `Bearer ${this.sessionService.getApplicationToken()}`;
      } else {
        headers['Authorization'] = `Bearer ${this.sessionService.getCustomMfaToken()}`;
      }
    } else if (this.s3Urls.includes(request.url)) {
      if (request.url.includes('api/upload/')) {
        delete s3Headers['Content-Type'];
      }
      request = request.clone({
        url: `${environment.s3Service.s3_api_url}${request.url}`,
        setHeaders: s3Headers,
      });
    } else if (request.url == 'data/2.5/weather') {
      api_url = `https://api.openweathermap.org/data/2.5/weather`;
    } else {
      headers['Content-Type'] = 'application/json';
      headers['Authorization'] = `Bearer ${this.sessionService.getApplicationToken()}`;
      api_url = `${environment.api_url}/api/v2${request.url}`;
    }
    request = request.clone({
      url: api_url,
      setHeaders: headers,
    });
    return next.handle(request).pipe(
      catchError((error) => {
        return throwError(error);
      })
    );
  }
}
